import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { Collapse, Nav, Navbar, NavbarToggler } from "reactstrap";
import Dropdown from "react-bootstrap/Dropdown";
import "./Index.scss";
import header_logo from "../../images/Header_logo_1.png";
import NavigateComponent from "./NavigateComponent";
import Badge from "@mui/material/Badge";
import { useDispatch, useSelector } from "react-redux";
// import { LoginUser } from "../../reducers/login";
import Config from "../../Utils/Config";
import pro_img from "../../images/default_profile.jpg";
import {
  Backdrop,
  CircularProgress,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Tooltip,
} from "@mui/material";
import MenuBookRounded from "@mui/icons-material/MenuBookRounded";
import HelpOutlineRounded from "@mui/icons-material/HelpOutlineRounded";
import ChatBubbleOutlineRounded from "@mui/icons-material/ChatBubbleOutlineRounded";
import NotificationsNoneRounded from "@mui/icons-material/NotificationsNoneRounded";
// import { resetSetting } from "../../reducers/setting";
import information from "../../images/Icon/information.svg";
import axios from "axios";
import { PostCallApi } from "./../../Action/Action";
import { useSignalR } from "../../Utils/SignalRContext";
import { SwalError, SwalMessage } from "../../components/SwalToast";
import { persistor } from "../../store";
import { clearSessionStorage } from "../../Utils/clearSessionStorage";
// import { DefaultDashboardType } from "../../reducers/Common";
// import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";

const user_mennul = "/assets/user_mennul.svg";

function Navigation(props) {
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [openCircle, setOpenCircle] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openNotification = Boolean(anchorEl);
  const [notificationList, setNotificationList] = useState([]);
  const [readNotification, setReadNotification] = useState(false);
  let nav = useNavigate();
  let dispatch = useDispatch();
  const token = useSelector((state) => state.login.LoginDetails.accessToken);
  const LoginId = useSelector((state) => state.login.LoginDetails);
  const { connection } = useSignalR();

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
    Accept: "*/*",
  };
  let LoginUserd = useSelector((state) => state.login?.LoginDetails);
  const handleClick = (event) => {
    if (notificationList?.length > 0) {
      setAnchorEl(event?.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNav = async (redirect) => {
    setOpenCircle(true);
    let apiBody = {
      createdBy: LoginId?.userId,
      logOutName: LoginId?.firstName + " " + LoginId?.lastName,
      email: LoginId?.email,
      type: "Web",
    };

    let sendData = {
      url: `/api/Common/SaveUserActivityLogOut`,
      body: apiBody,
    };

    let resp = await PostCallApi(sendData);
    setOpenCircle(false);
    if (resp?.status === 200 && resp?.data?.success) {
      clearSessionStorage();
      nav(redirect ? redirect : "/", { replace: true });
      setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        persistor.purge();
      }, 0);
    } else {
      SwalError(resp?.data?.message);
    }
  };
  useEffect(() => {
    getNotification();
    const interval = setInterval(() => getNotification(), 60000);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, [readNotification]);

  useEffect(() => {
    if (connection && LoginId?.userId) {
      connection?.on("MenuUpdateOnlineUser", (data) => {
        handleMessage(data);
      });
    }
    // eslint-disable-next-line
  }, [connection?.state]);
  const handleMessage = async (data) => {
    let rv = await SwalMessage(data);
    if (rv?.isConfirmed) handleNav("/login");
  };

  const getNotification = () => {
    axios
      .get(
        `${Config.API_HOST_URL_live}/api/Common/GetNotificationByUserId?userId=${LoginUserd.userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "*/*",
          },
        },
      )
      .then((response) => {
        if (response.data.success) {
          let notificationData = response.data.payload?.map((notify, i) => {
            // if (notify.isRead === false) {
            return {
              isRead: notify.isRead,
              notificationId: notify?.notificationId,
              notificationText: notify?.notificationText,
              relatedId: notify?.relatedId,
              userId: notify.user?.userId,
              user: notify.user?.firstName + " " + notify.user?.lastName,
              imgUser:
                notify?.user?.profileUrl === undefined ||
                  notify?.user?.profileUrl === "" ||
                  notify?.user?.profileUrl === null
                  ? pro_img
                  : `${Config.API_HOST_URL_live}${notify?.user?.profileUrl}`,
              notificationType: notify?.notificationType,
              createdOn: notify?.createdOn,
              createdBy: notify?.createdBy,
              linkUrl: notify?.linkUrl,
            };
            // }
            // return 0;
          });
          notificationData = notificationData.filter(function (element) {
            return element !== undefined;
          });
          notificationData = notificationData.filter(function (element) {
            return element !== 0;
          });
          setNotificationList(notificationData);
        } else {
          setNotificationList([]);
        }
      });
  };
  const HandleNotificationRedirect = (e) => {
    axios
      .post(
        `${Config.API_HOST_URL_live}/api/Common/UpdateNotification?notificationId=${e.notificationId}`,
        {},
        { headers },
      )
      .then((response) => {
        if (response.data.success) {
          setReadNotification(!readNotification);
        }
      });

    if (e?.notificationType === "message" || e?.notificationType === "chat") {
      nav(`/messages/${e?.relatedId}`, { replace: true });
    } else if (e?.notificationType === "userprofile") {
      nav(`/edit-profile`, { replace: true });
    } else if (e?.notificationType === "sentrequest") {
      nav(`/edit-profile/${e?.relatedId}`, { replace: true });
    } else if (e?.notificationType === "direct") {
      if (e?.linkUrl) {
        window.open(e.linkUrl, "_blank", "noopener,noreferrer");
      }
    } else if (
      e?.notificationType === "post" ||
      e?.notificationType === "comment" ||
      e?.notificationType.toLowerCase() === "goal" ||
      e?.notificationType === "like"
    ) {
      nav(`/community/${e?.relatedId}`, { replace: true });
    } else if (e?.notificationType === "freesources") {
      nav(`/free-sources/${e?.relatedId}`, { replace: true });
    } else if (e?.notificationType === "communitygroup") {
      nav(`/community-groups/${e?.relatedId}`, { replace: true });
    } else if (e?.notificationType === "Assign Pathway") {
      nav(`/learning-paths/${e?.relatedId}`, { replace: true });
    } else if (
      e?.notificationType === "coursecomplete" ||
      e?.notificationType === "course" ||
      e?.notificationType === "courseupdate" ||
      e?.notificationType === "coursestart" ||
      e?.notificationType === "sendassigncoursetouser" ||
      e?.notificationType === "sendassignedcourseinstructore"
    ) {
      nav(`/ceu-courses/${e?.relatedId}`, { replace: true });
    } else if (e?.notificationType === "Pathway Approval Request") {
      nav(`/dashboard/notifications`, { replace: true });
    }
    handleClose();
  };

  const handleRead = async () => {
    let apiUrl = {
      url: `/api/Common/UpdateNotificationByUserId?userId=${LoginUserd.userId}`,
    };
    let resp = await PostCallApi(apiUrl);
    if (resp?.status === 200) {
      if (resp?.data?.success) {
        getNotification();
        handleClose();
      }
    }
  };

  const [isModern, setIsModern] = useState(
    () => JSON.parse(localStorage.getItem("default_dashboard_type")) || false,
  );
  const toggleDashboard = () => {
    const newType = !isModern;
    localStorage.setItem("default_dashboard_type", JSON.stringify(newType));
    // Remember that the user chose their own dashboard, so it isn't reset to the district
    // default on the next login. The district value is only the starting default.
    localStorage.setItem("dashboard_user_choice", "1");
    window.dispatchEvent(new Event("storage"));
    setIsModern(newType);
  };
  const handleSideNav = () => {
    props?.setIsSidebarChatOpen(false);
    props?.setIsOpen(!props?.isOpen);
  };

  const closeSideNav = () => {
    props?.setIsOpen(false);
  };
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={openCircle}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <section className={`navigation`}>
        <div className="container-fluid">
          <div className="main_wrapper">
            <Navbar expand="xl" className="nav_bar">
              <div className="mobile_toggle">
                <NavLink onClick={() => handleSideNav()}>
                  <img
                    src={header_logo}
                    className="header_logo img-fluid"
                    alt="header_logo"
                  />
                </NavLink>
                <NavbarToggler
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3 12H16"
                      stroke="#666666"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 6H21"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M3 18H21"
                      stroke="#fff"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </NavbarToggler>
              </div>
              <Collapse isOpen={isOpen} navbar className="header_nav">
                <div className="logo-btn-div">
                  {/* <button type="button" onClick={() => handleSideNav()} className="toggle-btn">
                    {props?.isOpen ? <AiOutlineClose /> : <AiOutlineMenu />}
                  </button> */}
                  <NavLink
                    onClick={() => handleSideNav()}
                    className="main_logo"
                  >
                    <img
                      src={header_logo}
                      className="header_logo"
                      alt="header_logo"
                    />
                  </NavLink>
                </div>
                <NavigateComponent
                  closeSideNav={closeSideNav}
                  setIsOpen={props?.setIsOpen}
                />
                <Nav navbar className="nav_action align-items-center">
                  {pathname === "/dashboard" && (
                    <Tooltip
                      title={`Switch to ${isModern ? "modern" : "classic"
                        } dashboard`}
                      placement="top"
                      arrow
                      className="tooltip_manage"
                    >
                      <label className="dashboard_toggle_switch">
                        <span className={`switch-wrapper`}>
                          <input
                            type="checkbox"
                            checked={isModern}
                            onChange={toggleDashboard}
                          />
                          <span
                            className={`${isModern ? "btn-success" : "btn-danger"
                              } switch`}
                          >
                            <span className="switch-handle" />
                          </span>
                        </span>
                      </label>
                    </Tooltip>
                  )}
                  <Tooltip
                    title="FIG User Manual"
                    placement="top"
                    arrow
                    className="tooltip_manage"
                  >
                    <div>
                      <Link
                        to={`${Config.API_HOST_URL_live}/Manuals/employee_role_user_manual.pdf`}
                        className="header_search_button "
                        // className="header_search_button btn"
                        target="_blank"
                      // download
                      >
                        <MenuBookRounded sx={{ fontSize: 22, color: "#6c5ce7" }} />
                      </Link>
                    </div>
                  </Tooltip>
                  <Tooltip
                    title="Help"
                    placement="top-start"
                    arrow
                    className="tooltip_manage "
                  >
                    <div>
                      <Link
                        to={"/help"}
                        className="header_search_button "
                      // onClick={handleHelp}
                      >
                        <HelpOutlineRounded sx={{ fontSize: 22, color: "#f79153" }} />
                      </Link>
                    </div>
                  </Tooltip>
                  <Tooltip
                    title="Message"
                    placement="top-start"
                    arrow
                    className="tooltip_manage "
                  >
                    <div>
                      <Link
                        to={"/messages"}
                        className="header_search_button "
                      // onClick={handleMessage}
                      >
                        <Badge>
                          <ChatBubbleOutlineRounded sx={{ fontSize: 22, color: "#1ebec8" }} />
                        </Badge>
                      </Link>
                    </div>
                  </Tooltip>

                  <Tooltip
                    title="Notification"
                    placement="top-start"
                    arrow
                    className="tooltip_manage last"
                  >
                    <div>
                      <Button
                        className="header_search_button"
                        onClick={handleClick}
                        sx={{ minWidth: "max-content", padding: "0px" }}
                      >
                        <Badge
                          badgeContent={
                            notificationList
                              ? notificationList?.filter(
                                (x) => x?.isRead === false,
                              )?.length
                              : 0
                          }
                        >
                          <NotificationsNoneRounded sx={{ fontSize: 22, color: "#fa4747" }} />
                        </Badge>
                      </Button>
                    </div>
                  </Tooltip>

                  <Dropdown className="drop_down">
                    <Dropdown.Toggle className="header_option ">
                      <img
                        src={
                          // LoginUserd?.profileUrl === "" ||
                          //   LoginUserd?.profileUrl === null
                          //   ? pro_img
                          //   : `${Config.API_HOST_URL_live}${LoginUserd?.profileUrl}`
                          LoginUserd?.thumbnailProfileUrl === "" ||
                            LoginUserd?.thumbnailProfileUrl === null
                            ? pro_img
                            : `${Config.API_HOST_URL_live}${LoginUserd?.thumbnailProfileUrl}`
                        }
                        alt="profile"
                        className="user_profile"
                      />
                      {/* {window.innerWidth < 992 || window.innerWidth > 1200 ? ( */}
                      {/* <div className="profile_info">
                        <span className={`header_login_icon `}>
                          {LoginUserd?.firstName + " " + LoginUserd?.lastName}
                        </span>
                        <span className={`header_login_icon role d-block`}>
                          {LoginUserd?.roleName}
                        </span>
                        <span className="header_login_icon district_name d-block">
                          {LoginUserd?.schooldistrictName}
                        </span>
                      </div> */}
                      {/* ) : (
                        ""
                      )} */}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {/* {window.innerWidth < 1200 && window.innerWidth > 992 ? (
                        <> */}
                      <di className="w-100 ">
                        <div
                          className="profile_info"
                          style={{ marginLeft: "10px", padding: "0 8px" }}
                        >
                          <span className={`header_login_icon `}>
                            {LoginUserd?.firstName + " " + LoginUserd?.lastName}
                          </span>
                          <span
                            className={`header_login_icon p_14_text role d-block`}
                            style={{ color: " #36454F" }}
                          >
                            {LoginUserd?.roleName}
                          </span>
                          <span
                            className="header_login_icon p_14_text district_name d-block"
                            style={{ color: " #36454F" }}
                          >
                            {LoginUserd?.schooldistrictName}
                          </span>
                        </div>
                      </di>
                      <Dropdown.Divider />
                      {/* </>
                      ) : (
                        ""
                      )} */}
                      <IconButton className="w-100 logout_bnt">
                        <Link
                          className="header_user_Link w-100 d-flex justify-content-start"
                          to="/edit-profile"
                        >
                          <span className="header_user_link_text1">
                            Profile
                          </span>
                        </Link>
                      </IconButton>
                      <Dropdown.Divider />
                      <IconButton className="w-100 logout_bnt">
                        <Link
                          className="header_user_Link w-100 d-flex justify-content-start"
                          to="/email-preference"
                        >
                          <span className="header_user_link_text1">
                            Email Preference
                          </span>
                        </Link>
                      </IconButton>
                      <Dropdown.Divider />
                      {/* <IconButton className="w-100 logout_bnt">
                        <Link
                          className="header_user_Link w-100 d-flex justify-content-start"
                          to="/privacy"
                        >
                          <span className="header_user_link_text1">
                            Privacy
                          </span>
                        </Link>
                      </IconButton>              
                      <Dropdown.Divider /> */}
                      <IconButton className="w-100 logout_bnt">
                        <Link
                          className="header_user_Link w-100 d-flex justify-content-start"
                          to="/logged-reset-password"
                        >
                          <span className="header_user_link_text1">
                            Reset Password
                          </span>
                        </Link>
                      </IconButton>
                      <Dropdown.Divider />
                      <IconButton
                        onClick={() => handleNav()}
                        className="w-100 logout_bnt"
                      >
                        <span className="header_user_link_text2">Logout</span>
                      </IconButton>
                    </Dropdown.Menu>
                  </Dropdown>
                </Nav>
              </Collapse>
            </Navbar>
          </div>
        </div>
      </section>
      <Menu
        className="notification_list"
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={openNotification}
        onClose={handleClose}
      >
        {notificationList?.map((notifi, i) => {
          return (
            <MenuItem
              className={`${notifi?.isRead ? "noShow_colors" : "show_color"}`}
              key={i}
              onClick={() => HandleNotificationRedirect(notifi)}
            >
              <div className="notification_box">
                <div className="img_box me-3">
                  <img src={notifi?.imgUser} alt="" />
                </div>
                <div className="notification_msg">
                  <div className="p_16_text">{notifi?.user}</div>
                  <div className="p_14_text">{notifi?.notificationText}</div>
                </div>
              </div>
            </MenuItem>
          );
        })}
        {notificationList?.filter((x) => x?.isRead === false)?.length > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              position: "sticky",
              bottom: 0,
            }}
          >
            <div className="mark_as_read">
              <Link onClick={handleRead}>Mark all as read</Link>
            </div>
            <div className="mark_as_read">
              <Link to="/dashboard/notifications" onClick={handleClose}>
                View all Notifications
              </Link>
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              position: "sticky",
              bottom: 0,
            }}
          >
            <div className="mark_as_read">
              <Link onClick={handleClose}>Mark all as read</Link>
            </div>
            <div className="mark_as_read">
              <Link to="/dashboard/notifications" onClick={handleClose}>
                View all Notifications
              </Link>
            </div>
          </div>
        )}
        {/* {notificationList?.filter((x) => x?.isRead === false)?.length > 0 ? (
          <div className="mark_as_read">
            <Link onClick={handleRead}>Mark all as read</Link>
          </div>
        ) : (
          <div className="mark_as_read">
            <Link onClick={handleClose}>Mark all as read</Link>
          </div>
        )} */}
      </Menu>
    </>
  );
}

export default React.memo(Navigation);
